import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import footerLogo from "../media/logo/footerLogo.png";
import { useNavigate } from "react-router-dom";

const HeaderContainer = styled.header.attrs(({ height }) => ({
  style: { height },
}))`
  width: 100vw;
  display: flex;
  position: ${({ isSticky }) => (isSticky ? "fixed" : "relative")};
  top: ${({ isSticky }) => (isSticky ? "0" : "auto")};
  right: 0;
  left: 0;
  background: white;
  transition: transform 0.3s ease-in-out;
  transform: ${({ isSticky, isHidden }) =>
    isSticky && isHidden ? "translateY(-100%)" : "translateY(0)"};
  z-index: 1000;
  box-shadow: 0 5px 6px -6px #777;
`;

const InnerContent = styled(Box)`
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
`;

const Logo = styled.img`
  height: 30px;
  cursor: pointer;
  @media (min-width: 1440px) {
    height: 38px;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 32px;
`;

const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Outfit", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #1e3a8a;
  @media (min-width: 1440px) {
    font-size: 18px;
  }
`;

const SolidButton = styled(Button)`
  && {
    background: #1e3a8a;
    color: #ffffff;
    border-radius: 24px;
    padding: 6px 14px;
    font-weight: 400;
    text-transform: none;
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    min-width: 120px;
    height: 40px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    @media (min-width: 1440px) {
      font-size: 18px;
    }
    &:hover {
      background: #1e3a8a;
    }
  }
`;

const HeaderDimensions = { height: "60px" };

const HeaderDesktop = ({
  headerData,
  pageWidthCalc,
  headerPosition,
  sectionPositions,
}) => {
  const [isHidden, setIsHidden] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!headerData?.is_sticky) return;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setIsHidden(currentScrollPos > prevScrollPos && currentScrollPos > 100);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, headerData?.is_sticky]);

  const navItems = ["solutions", "aboutus"];

  const handleSectionNav = (key) => {
    const match = sectionPositions?.find(
      (section) => section.text.toLowerCase() === key
    );

    if (match) {
      window.scrollTo({ top: match.top, behavior: "smooth" });
    } else {
      navigate("/home", { state: { scrollToSection: key } });
    }
  };

  return (
    <HeaderContainer
      isSticky={headerData?.is_sticky}
      isHidden={isHidden}
      height={HeaderDimensions?.height}
    >
      <InnerContent
        style={{
          left: `${headerPosition}px`,
          width: `${pageWidthCalc}px`,
          height: HeaderDimensions?.height,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "32px" }}>
          <Logo
            src={footerLogo}
            alt="Logo"
            onClick={() => navigate(`/${process.env.REACT_APP_DEFAULT_URL}`)}
          />
          <NavLinks>
            <NavButton
              onClick={() => navigate(`/${process.env.REACT_APP_DEFAULT_URL}`)}
            >
              Home
            </NavButton>

            {navItems.map((item) => (
              <NavButton key={item} onClick={() => handleSectionNav(item)}>
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </NavButton>
            ))}
          </NavLinks>
        </Box>
        <SolidButton onClick={() => navigate("/contactus")} variant="contained">
          Talk to us
        </SolidButton>
      </InnerContent>
    </HeaderContainer>
  );
};

export default HeaderDesktop;
